import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-small-logo',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="size"
      [attr.height]="size"
      viewBox="0 0 48 48"
      fill="none"
    >
      <g clip-path="url(#clip0_71_29831)">
        <rect
          x="-0.00939941"
          y="-0.00469971"
          width="48"
          height="48"
          rx="11.52"
          fill="#8CD2FF"
        />
        <path
          d="M0.166963 24.0282C-0.567077 24.5856 -1.59482 23.6423 -1.00657 22.9328C7.4528 12.7298 28.1233 -7.1383 59.8106 -5.51049C60.4257 -5.47889 60.741 -4.79125 60.32 -4.34163C57.3442 -1.16333 47.3417 8.11948 29.7573 10.988C16.4484 13.159 6.0834 19.536 0.166963 24.0282Z"
          fill="url(#paint0_linear_71_29831)"
        />
        <path
          d="M-13.0774 34.5396C-13.0774 34.5396 16.7748 7.51613 40.9711 14.803C41.6011 14.9927 41.6583 15.8022 41.0607 16.0773C37.4587 17.7354 27.4454 21.7512 11.4954 23.6359C-8.88933 26.0445 -13.1283 35.1346 -13.1283 35.1346"
          fill="url(#paint1_linear_71_29831)"
        />
        <path
          d="M-0.796289 32.4678C-0.796186 32.4678 -0.796084 32.4678 -0.795986 32.4678L6.25916 30.2069C7.56211 29.7894 8.92653 30.8335 9.05828 32.1954C9.44427 36.1852 11.3125 42.9011 19.5394 42.6362C29.003 42.3314 28.5343 31.5075 28.0174 27.4187C27.9031 26.5152 28.3722 25.615 29.2072 25.2515L35.9837 22.3011C37.0832 21.8224 38.3267 22.4494 38.5041 23.6353C39.5582 30.6818 40.9788 51.9161 20.166 53.43C18.4627 53.4505 12.6956 53.5758 7.44677 49.8047C-0.725862 43.9318 -0.806351 33.5926 -0.797281 32.4686C-0.797276 32.4681 -0.796835 32.4678 -0.796289 32.4678Z"
          fill="#FFB300"
        />
        <path
          d="M-0.796289 32.4678C-0.796186 32.4678 -0.796084 32.4678 -0.795986 32.4678L6.25916 30.2069C7.56211 29.7894 8.92653 30.8335 9.05828 32.1954C9.44427 36.1852 11.3125 42.9011 19.5394 42.6362C29.003 42.3314 28.5343 31.5075 28.0174 27.4187C27.9031 26.5152 28.3722 25.615 29.2072 25.2515L35.9837 22.3011C37.0832 21.8224 38.3267 22.4494 38.5041 23.6353C39.5582 30.6818 40.9788 51.9161 20.166 53.43C18.4627 53.4505 12.6956 53.5758 7.44677 49.8047C-0.725862 43.9318 -0.806351 33.5926 -0.797281 32.4686C-0.797276 32.4681 -0.796835 32.4678 -0.796289 32.4678Z"
          fill="url(#paint2_linear_71_29831)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_71_29831"
          x1="27.9586"
          y1="-5.60471"
          x2="27.9586"
          y2="28.7633"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1976D2" />
          <stop offset="1" stop-color="#0C4BC4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_71_29831"
          x1="15.8771"
          y1="12.002"
          x2="13.6483"
          y2="37.4773"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1976D2" />
          <stop offset="1" stop-color="#0C4BC4" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_71_29831"
          x1="19.1085"
          y1="21.3812"
          x2="19.1085"
          y2="53.4353"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FBA52B" />
          <stop offset="1" stop-color="#F9DA11" />
        </linearGradient>
        <clipPath id="clip0_71_29831">
          <rect
            x="-0.00939941"
            y="-0.00469971"
            width="48"
            height="48"
            rx="11.52"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  `,
})
export class SmallLogoComponent {
  @Input() size: number = 48;
}
